"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var ImageWrapper = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    top: 10px;\n    ", "\n"], ["\n    position: relative;\n    top: 10px;\n    ", "\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  var medium = responsive_1.isMedium(activeBreakpoint);
  return "\n            width: " + (medium ? 60 : 80) + "px;\n            height: " + (medium ? 60 : 80) + "px;\n        ";
});
exports.default = responsive_1.withResponsiveMeta(ImageWrapper);
var templateObject_1;